import { render, staticRenderFns } from "./paymentAlipay.vue?vue&type=template&id=6d005f60&"
import script from "./paymentAlipay.vue?vue&type=script&lang=js&"
export * from "./paymentAlipay.vue?vue&type=script&lang=js&"
import style0 from "./paymentAlipay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports